module.exports = __webpack_public_path__ + "static/img/ScreenShot_2026-05-07_151938_292.85e70c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ScreenShot_2026-05-07_151938_292.png
// module id = jni8
// module chunks = 1